<template>
  <!--  <v-btn outlined icon v-bind="$attrs" @click="$router.go(to)" class="back-btn">-->
  <!--    <v-icon class="pointerEvents">mdi-arrow-left</v-icon>-->
  <!--  </v-btn>-->
  <button class="back-btn" @click="$router.go(to)">
    <v-icon class="pointer-events-none">mdi-arrow-left</v-icon>
  </button>
</template>

<script>
export default {
  name: "back-btn",
  props: {
    to: {
      default: -1,
    },
  },
};
</script>

<style>
.back-btn {
  background: #ffffff;
  border: 1px solid #dfe2e9;
  box-shadow: 0px 1px 2px rgba(14, 49, 88, 0.102);
  border-radius: 6px;
  padding: 5px 6px;
}

.pointer-events-none {
  pointer-events: none !important;
}
</style>
